(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["latest-articles-all-blog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sectionSelector = '.gr-latest-articles';
    var carouselSelector = '.gr-latest-articles__carousel';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var pauseObservers = new WeakMap();

    function getCarousel(section) {
      return section ? section.querySelector(carouselSelector) : null;
    }

    function withSwiper(carousel, callback, attempts) {
      if (!carousel) return;

      if (carousel.swiper && carousel.swiper.autoplay) {
        callback(carousel.swiper);
        return;
      }

      if (attempts > 0) {
        window.requestAnimationFrame(function () {
          withSwiper(carousel, callback, attempts - 1);
        });
      }
    }

    function pauseAutoplay(section) {
      var carousel = getCarousel(section);

      withSwiper(carousel, function (swiper) {
        swiper.autoplay.stop();
      }, 120);
    }

    function resumeAutoplay(section) {
      var carousel = getCarousel(section);

      if (!carousel || reduceMotion.matches) return;
      if (document.hidden || section.contains(document.activeElement)) return;

      withSwiper(carousel, function (swiper) {
        swiper.autoplay.start();
      }, 120);
    }

    function initializeSection(section) {
      if (!section) return;

      var carousel = getCarousel(section);

      if (!carousel) return;

      if (reduceMotion.matches) {
        pauseAutoplay(section);
      }

      if ('IntersectionObserver' in window && !pauseObservers.has(carousel)) {
        var pauseObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;

            var shouldRemainPaused = section.contains(document.activeElement)
              || document.hidden
              || reduceMotion.matches;

            if (shouldRemainPaused) {
              window.requestAnimationFrame(function () {
                pauseAutoplay(section);
              });
            }
          });
        }, { threshold: 0.2 });

        pauseObserver.observe(carousel);
        pauseObservers.set(carousel, pauseObserver);
      }
    }

    function initializeAll(root) {
      if (root.matches && root.matches(sectionSelector)) initializeSection(root);
      root.querySelectorAll(sectionSelector).forEach(initializeSection);
    }

    document.addEventListener('focusin', function (event) {
      var section = event.target.closest(sectionSelector);
      if (section) pauseAutoplay(section);
    });

    document.addEventListener('focusout', function (event) {
      var section = event.target.closest(sectionSelector);
      if (!section) return;

      window.requestAnimationFrame(function () {
        if (!section.contains(document.activeElement)) resumeAutoplay(section);
      });
    });

    document.addEventListener('visibilitychange', function () {
      document.querySelectorAll(sectionSelector).forEach(function (section) {
        if (document.hidden) {
          pauseAutoplay(section);
        } else {
          resumeAutoplay(section);
        }
      });
    });

    function handleReducedMotion() {
      document.querySelectorAll(sectionSelector).forEach(function (section) {
        if (reduceMotion.matches) {
          pauseAutoplay(section);
        } else {
          resumeAutoplay(section);
        }
      });
    }

    if (reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', handleReducedMotion);
    } else {
      reduceMotion.addListener(handleReducedMotion);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAll(document);
      });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var carousel = event.target.querySelector(carouselSelector);
      var pauseObserver = carousel ? pauseObservers.get(carousel) : null;

      if (pauseObserver) {
        pauseObserver.disconnect();
        pauseObservers.delete(carousel);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
